/*!
 * 生成物。手で編集しない。
 * 生成コマンド: php artisan exa:generate-kanji-variant-map
 * 出典: Unicode Unihan Database 18.0.0 (Unihan_Variants.txt, kJapaneseNewVariant)
 *
 * UNICODE LICENSE V3
 *
 * COPYRIGHT AND PERMISSION NOTICE
 *
 * Copyright © 1991-2026 Unicode, Inc.
 *
 * NOTICE TO USER: Carefully read the following legal agreement. BY
 * DOWNLOADING, INSTALLING, COPYING OR OTHERWISE USING DATA FILES, AND/OR
 * SOFTWARE, YOU UNEQUIVOCALLY ACCEPT, AND AGREE TO BE BOUND BY, ALL OF THE
 * TERMS AND CONDITIONS OF THIS AGREEMENT. IF YOU DO NOT AGREE, DO NOT
 * DOWNLOAD, INSTALL, COPY, DISTRIBUTE OR USE THE DATA FILES OR SOFTWARE.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of data files and any associated documentation (the "Data Files") or
 * software and any associated documentation (the "Software") to deal in the
 * Data Files or Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, and/or sell
 * copies of the Data Files or Software, and to permit persons to whom the
 * Data Files or Software are furnished to do so, provided that either (a)
 * this copyright and permission notice appear with all copies of the Data
 * Files or Software, or (b) this copyright and permission notice appear in
 * associated Documentation.
 *
 * THE DATA FILES AND SOFTWARE ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
 * KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF
 * THIRD PARTY RIGHTS.
 *
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS INCLUDED IN THIS NOTICE
 * BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR CONSEQUENTIAL DAMAGES,
 * OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS,
 * WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION,
 * ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THE DATA
 * FILES OR SOFTWARE.
 *
 * Except as contained in this notice, the name of a copyright holder shall
 * not be used in advertising or otherwise to promote the sale, use or other
 * dealings in these Data Files or Software without prior written
 * authorization of the copyright holder.
 */

// 旧字体 => 新字体 (すべて BMP 内の 1 字 → 1 字)
export const kanjiVariantMap = {
  '\u4E58': '\u4E57',
  '\u4E82': '\u4E71',
  '\u4E9E': '\u4E9C',
  '\u4F5B': '\u4ECF',
  '\u4F86': '\u6765',
  '\u5002': '\u4F75',
  '\u5047': '\u4EEE',
  '\u50B3': '\u4F1D',
  '\u50DE': '\u507D',
  '\u50F9': '\u4FA1',
  '\u5109': '\u5039',
  '\u5152': '\u5150',
  '\u5169': '\u4E21',
  '\u5269': '\u5270',
  '\u528D': '\u5263',
  '\u5291': '\u5264',
  '\u52DE': '\u52B4',
  '\u52F3': '\u52F2',
  '\u52F5': '\u52B1',
  '\u52F8': '\u52E7',
  '\u5340': '\u533A',
  '\u5377': '\u5DFB',
  '\u537D': '\u5373',
  '\u53C3': '\u53C2',
  '\u55AE': '\u5358',
  '\u56B4': '\u53B3',
  '\u56D1': '\u5631',
  '\u5708': '\u570F',
  '\u570B': '\u56FD',
  '\u570D': '\u56F2',
  '\u5713': '\u5186',
  '\u5716': '\u56F3',
  '\u5718': '\u56E3',
  '\u589E': '\u5897',
  '\u58AE': '\u5815',
  '\u58D3': '\u5727',
  '\u58D8': '\u5841',
  '\u58DE': '\u58CA',
  '\u58E4': '\u58CC',
  '\u58EF': '\u58EE',
  '\u58F9': '\u58F1',
  '\u58FD': '\u5BFF',
  '\u5967': '\u5965',
  '\u596C': '\u5968',
  '\u5B43': '\u5B22',
  '\u5B78': '\u5B66',
  '\u5BE2': '\u5BDD',
  '\u5BE6': '\u5B9F',
  '\u5BEB': '\u5199',
  '\u5BEC': '\u5BDB',
  '\u5BF6': '\u5B9D',
  '\u5C07': '\u5C06',
  '\u5C08': '\u5C02',
  '\u5C0D': '\u5BFE',
  '\u5C46': '\u5C4A',
  '\u5C6C': '\u5C5E',
  '\u5CFD': '\u5CE1',
  '\u5DBD': '\u5CB3',
  '\u5DE2': '\u5DE3',
  '\u5E36': '\u5E2F',
  '\u5EE2': '\u5EC3',
  '\u5EE3': '\u5E83',
  '\u5EF3': '\u5E81',
  '\u5F48': '\u5F3E',
  '\u5F4C': '\u5F25',
  '\u5F91': '\u5F84',
  '\u5F9E': '\u5F93',
  '\u5FB5': '\u5FB4',
  '\u5FB7': '\u5FB3',
  '\u6046': '\u6052',
  '\u60E0': '\u6075',
  '\u60E1': '\u60AA',
  '\u60F1': '\u60A9',
  '\u613C': '\u614E',
  '\u6158': '\u60E8',
  '\u61C9': '\u5FDC',
  '\u61F7': '\u61D0',
  '\u6200': '\u604B',
  '\u6230': '\u6226',
  '\u6232': '\u622F',
  '\u623E': '\u623B',
  '\u62C2': '\u6255',
  '\u62D4': '\u629C',
  '\u62DC': '\u62DD',
  '\u633E': '\u631F',
  '\u63D2': '\u633F',
  '\u63ED': '\u63B2',
  '\u6416': '\u63FA',
  '\u641C': '\u635C',
  '\u64C7': '\u629E',
  '\u64CA': '\u6483',
  '\u64D4': '\u62C5',
  '\u64DA': '\u62E0',
  '\u64E7': '\u6319',
  '\u64F4': '\u62E1',
  '\u651D': '\u6442',
  '\u6536': '\u53CE',
  '\u6548': '\u52B9',
  '\u654D': '\u53D9',
  '\u6555': '\u52C5',
  '\u6578': '\u6570',
  '\u65B7': '\u65AD',
  '\u665A': '\u6669',
  '\u665D': '\u663C',
  '\u66C6': '\u66A6',
  '\u66C9': '\u6681',
  '\u66FE': '\u66FD',
  '\u6703': '\u4F1A',
  '\u689D': '\u6761',
  '\u68E7': '\u685F',
  '\u69AE': '\u6804',
  '\u69EA': '\u6982',
  '\u6A02': '\u697D',
  '\u6A13': '\u697C',
  '\u6A1E': '\u67A2',
  '\u6A23': '\u69D8',
  '\u6A6B': '\u6A2A',
  '\u6AA2': '\u691C',
  '\u6AFB': '\u685C',
  '\u6B0A': '\u6A29',
  '\u6B50': '\u6B27',
  '\u6B61': '\u6B53',
  '\u6B65': '\u6B69',
  '\u6B77': '\u6B74',
  '\u6B78': '\u5E30',
  '\u6B98': '\u6B8B',
  '\u6BBC': '\u6BBB',
  '\u6BC6': '\u6BB4',
  '\u6BCF': '\u6BCE',
  '\u6C23': '\u6C17',
  '\u6D89': '\u6E09',
  '\u6DDA': '\u6D99',
  '\u6DE8': '\u6D44',
  '\u6DFA': '\u6D45',
  '\u6E34': '\u6E07',
  '\u6EAA': '\u6E13',
  '\u6EAB': '\u6E29',
  '\u6EEF': '\u6EDE',
  '\u6EFF': '\u6E80',
  '\u6F5B': '\u6F5C',
  '\u6F81': '\u6E0B',
  '\u6FA4': '\u6CA2',
  '\u6FD5': '\u6E7F',
  '\u6FDF': '\u6E08',
  '\u6FF1': '\u6D5C',
  '\u7027': '\u6EDD',
  '\u7028': '\u702C',
  '\u7063': '\u6E7E',
  '\u71C8': '\u706F',
  '\u71D2': '\u713C',
  '\u71DF': '\u55B6',
  '\u7210': '\u7089',
  '\u722D': '\u4E89',
  '\u7232': '\u70BA',
  '\u72A7': '\u72A0',
  '\u72C0': '\u72B6',
  '\u72F9': '\u72ED',
  '\u7368': '\u72EC',
  '\u7375': '\u731F',
  '\u7378': '\u7363',
  '\u737B': '\u732E',
  '\u74E3': '\u5F01',
  '\u7501': '\u74F6',
  '\u756B': '\u753B',
  '\u7576': '\u5F53',
  '\u758A': '\u7573',
  '\u7626': '\u75E9',
  '\u7661': '\u75F4',
  '\u767C': '\u767A',
  '\u76DC': '\u76D7',
  '\u76E1': '\u5C3D',
  '\u771E': '\u771F',
  '\u784F': '\u7814',
  '\u788E': '\u7815',
  '\u7955': '\u79D8',
  '\u79AA': '\u7985',
  '\u79AE': '\u793C',
  '\u7A31': '\u79F0',
  '\u7A3B': '\u7A32',
  '\u7A57': '\u7A42',
  '\u7A69': '\u7A4F',
  '\u7ACA': '\u7A83',
  '\u7ADD': '\u4E26',
  '\u7CB9': '\u7C8B',
  '\u7D72': '\u7CF8',
  '\u7D93': '\u7D4C',
  '\u7DA0': '\u7DD1',
  '\u7DD6': '\u7DD2',
  '\u7DE3': '\u7E01',
  '\u7E23': '\u770C',
  '\u7E31': '\u7E26',
  '\u7E3D': '\u7DCF',
  '\u7E69': '\u7E04',
  '\u7E6A': '\u7D75',
  '\u7E7C': '\u7D99',
  '\u7E8C': '\u7D9A',
  '\u7E96': '\u7E4A',
  '\u7F3A': '\u6B20',
  '\u7F50': '\u7F36',
  '\u8072': '\u58F0',
  '\u807D': '\u8074',
  '\u8085': '\u7C9B',
  '\u8166': '\u8133',
  '\u81BD': '\u80C6',
  '\u81DF': '\u81D3',
  '\u81FA': '\u53F0',
  '\u8207': '\u4E0E',
  '\u820A': '\u65E7',
  '\u8277': '\u8276',
  '\u838A': '\u8358',
  '\u8396': '\u830E',
  '\u842C': '\u4E07',
  '\u85B0': '\u85AB',
  '\u85CF': '\u8535',
  '\u85DD': '\u82B8',
  '\u85E5': '\u85AC',
  '\u8655': '\u51E6',
  '\u865B': '\u865A',
  '\u865F': '\u53F7',
  '\u87A2': '\u86CD',
  '\u87F2': '\u866B',
  '\u8836': '\u8695',
  '\u883B': '\u86EE',
  '\u885E': '\u885B',
  '\u88DD': '\u88C5',
  '\u8943': '\u8912',
  '\u89BA': '\u899A',
  '\u89BD': '\u89A7',
  '\u89C0': '\u89B3',
  '\u89F8': '\u89E6',
  '\u8B20': '\u8B21',
  '\u8B49': '\u8A3C',
  '\u8B6F': '\u8A33',
  '\u8B7D': '\u8A89',
  '\u8B80': '\u8AAD',
  '\u8B8A': '\u5909',
  '\u8B93': '\u8B72',
  '\u8C50': '\u8C4A',
  '\u8C6B': '\u4E88',
  '\u8CB3': '\u5F10',
  '\u8CE3': '\u58F2',
  '\u8CF4': '\u983C',
  '\u8D0A': '\u8CDB',
  '\u8E10': '\u8DF5',
  '\u8F15': '\u8EFD',
  '\u8F49': '\u8EE2',
  '\u8FA8': '\u5F01',
  '\u8FAD': '\u8F9E',
  '\u8FAF': '\u5F01',
  '\u905E': '\u9013',
  '\u9072': '\u9045',
  '\u908A': '\u8FBA',
  '\u90DE': '\u90CE',
  '\u9115': '\u90F7',
  '\u9189': '\u9154',
  '\u91AB': '\u533B',
  '\u91C0': '\u91B8',
  '\u91CB': '\u91C8',
  '\u9304': '\u9332',
  '\u9322': '\u92AD',
  '\u934A': '\u932C',
  '\u93AD': '\u93AE',
  '\u9435': '\u9244',
  '\u9444': '\u92F3',
  '\u945B': '\u9271',
  '\u95DC': '\u95A2',
  '\u9677': '\u9665',
  '\u96A8': '\u968F',
  '\u96AA': '\u967A',
  '\u96B1': '\u96A0',
  '\u96D9': '\u53CC',
  '\u96DC': '\u96D1',
  '\u9738': '\u8987',
  '\u9748': '\u970A',
  '\u975C': '\u9759',
  '\u986F': '\u9855',
  '\u98DC': '\u7FFB',
  '\u9918': '\u4F59',
  '\u9920': '\u9905',
  '\u9A37': '\u9A12',
  '\u9A45': '\u99C6',
  '\u9A57': '\u9A13',
  '\u9A5B': '\u99C5',
  '\u9AD3': '\u9AC4',
  '\u9AD4': '\u4F53',
  '\u9AEE': '\u9AEA',
  '\u9B2D': '\u95D8',
  '\u9DC4': '\u9D8F',
  '\u9E7D': '\u5869',
  '\u9EA5': '\u9EA6',
  '\u9EB5': '\u9EBA',
  '\u9EC3': '\u9EC4',
  '\u9ED1': '\u9ED2',
  '\u9ED8': '\u9ED9',
  '\u9EDE': '\u70B9',
  '\u9EE8': '\u515A',
  '\u9F4A': '\u6589',
  '\u9F4B': '\u658E',
  '\u9F52': '\u6B6F',
  '\u9F61': '\u9F62',
  '\u9F8D': '\u7ADC',
  '\u9F9C': '\u4E80',
  '\uF91D': '\u6B04',
  '\uF928': '\u5ECA',
  '\uF929': '\u6717',
  '\uF936': '\u865C',
  '\uF970': '\u6BBA',
  '\uF9D0': '\u985E',
  '\uF9DC': '\u9686',
  '\uFA10': '\u585A',
  '\uFA19': '\u795E',
  '\uFA1A': '\u7965',
  '\uFA1B': '\u798F',
  '\uFA22': '\u8AF8',
  '\uFA26': '\u90FD',
  '\uFA30': '\u4FAE',
  '\uFA31': '\u50E7',
  '\uFA32': '\u514D',
  '\uFA33': '\u52C9',
  '\uFA34': '\u52E4',
  '\uFA35': '\u5351',
  '\uFA36': '\u559D',
  '\uFA37': '\u5606',
  '\uFA38': '\u5668',
  '\uFA39': '\u5840',
  '\uFA3A': '\u58A8',
  '\uFA3B': '\u5C64',
  '\uFA3D': '\u6094',
  '\uFA3E': '\u6168',
  '\uFA3F': '\u618E',
  '\uFA40': '\u61F2',
  '\uFA41': '\u654F',
  '\uFA42': '\u65E2',
  '\uFA43': '\u6691',
  '\uFA44': '\u6885',
  '\uFA45': '\u6D77',
  '\uFA47': '\u6F22',
  '\uFA48': '\u716E',
  '\uFA4B': '\u7891',
  '\uFA4C': '\u793E',
  '\uFA4D': '\u7949',
  '\uFA4E': '\u7948',
  '\uFA50': '\u7956',
  '\uFA51': '\u795D',
  '\uFA52': '\u798D',
  '\uFA54': '\u7A40',
  '\uFA55': '\u7A81',
  '\uFA56': '\u7BC0',
  '\uFA57': '\u7DF4',
  '\uFA59': '\u7E41',
  '\uFA5A': '\u7F72',
  '\uFA5B': '\u8005',
  '\uFA5C': '\u81ED',
  '\uFA5F': '\u8457',
  '\uFA60': '\u8910',
  '\uFA61': '\u8996',
  '\uFA62': '\u8B01',
  '\uFA63': '\u8B39',
  '\uFA64': '\u8CD3',
  '\uFA65': '\u8D08',
  '\uFA67': '\u9038',
  '\uFA68': '\u96E3',
  '\uFA69': '\u97FF',
  '\uFA6A': '\u983B',
};
